import { StackablePageButtons, PageSection } from '@product-framework/index';
import ServiceAreaMap, {
  METERS_PER_STATUTE_MILE,
} from '@product-framework/components/ServiceAreaMap';

function ServiceArea() {
  const stackablePageButtons = [];
  const defaultLocation = {
    lat: 39.043,
    lng: -77.487,
  };
  /** Same coverage as previous 2000 m default (~1.24 statute mi). */
  const radiusMiles = 2000 / METERS_PER_STATUTE_MILE;
  return (
    <PageSection
      HeaderContent={
        <StackablePageButtons
          backButton={false}
          buttons={stackablePageButtons}
        />
      }
      headerProps={{ sx: { mb: 4 } }}>
      <ServiceAreaMap
        centerPoint={defaultLocation}
        radiusMiles={radiusMiles}
        zones={null}
        height={680}
        zoom={6}
        onChange={data => {
          // eslint-disable-next-line no-console
          console.log(data);
        }}
        onSaveChanges={data => {
          // eslint-disable-next-line no-console
          console.log(data);
        }}
        bulkImportCountryCode="US"
      />
    </PageSection>
  );
}
export default ServiceArea;
